/* ===================== NAVIGATION MENU ===================== */
function ccgetMenuItems(ele, arr, level = 1) {
    const ccItems = ele.children('div');
    ccItems.each(function() {
        const ccTitleLink = $(this).find('h5 a').first();
        if (!ccTitleLink.length) return;
        const name = ccTitleLink.text().trim();
        const link = ccTitleLink.attr('href') || '#';
        let icon = '';
        const ccImg = $(this).find('img').first();
        if (ccImg.length) icon = ccImg.attr('src');
        const newItem = {
            name,
            link,
            icon,
            submenu: [],
            level
        };
        const ccSubList = $(this).find('ul[class*="main-navigation-mega-list"]').first();
        if (ccSubList.length) {
            ccSubList.children('li').each(function() {
                const ccSubLink = $(this).find('a').first();
                if (ccSubLink.length) {
                    newItem.submenu.push({
                        name: ccSubLink.text().trim(),
                        link: ccSubLink.attr('href') || '#',
                        icon: '',
                        submenu: [],
                        level: level + 1
                    });
                }
            });
        }
        arr.push(newItem);
    });
}

function renderTwoColumnMenu(items, container) {
    const ccLeftCol = $('<div>').addClass('cc-nav-col cc-nav-left');
    container.append(ccLeftCol);

    items.forEach((menu, menuIndex) => {
        const ccMenuItem = $('<div>').addClass('cc-nv-main-item');
        const ccMenuLink = $('<a>')
            .addClass('cc-nav-link')
            .attr('href', menu.link)
            .attr('role', 'menuitem')
            .attr('tabindex', 0)
            .attr('aria-haspopup', menu.submenu.length > 0 ? 'true' : 'false')
            .attr('aria-expanded', 'false')
            .attr('data-cc-index', menuIndex)
            .append(`<span class="menu-text">${menu.name}</span>`);

        if (menu.icon) {
            ccMenuLink.prepend(`<img src="${menu.icon}" class="cc-nav-icon">`);
        }

        ccMenuItem.append(ccMenuLink);

        if (menu.submenu && menu.submenu.length > 0) {
            // arrow
            const ccArrow = $(`<button type="button" class="cc-nav-arrow" aria-hidden="true">
          <svg class="#icon"><use href="#svg-icon-angle-right"></use></svg>
        </button>`);
            ccMenuItem.append(ccArrow);

            // submenu container for THIS item
            const ccRightCol = $('<div>').addClass('cc-nav-col cc-nav-right').hide();
            const ccSubList = $('<div>').addClass('cc-nav-submenu');

            menu.submenu.forEach((sub) => {
                const ccSubItem = $('<div>').addClass('cc-nv-main-item');
                const ccSubLink = $('<a>').addClass('cc-nav-link').attr('href', sub.link).text(sub.name);

                ccSubItem.append(ccSubLink);
                ccSubList.append(ccSubItem);
            });

            ccRightCol.append(ccSubList);
            ccMenuItem.append(ccRightCol);

            // 🔹 Arrow click (mobile/touch support)
            ccArrow.on('click', (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                const isOpen = ccMenuItem.hasClass('cc-menu-active');

                if (isOpen) {
                    // Close
                    ccMenuItem.removeClass('cc-menu-active');
                    ccArrow.removeClass('cc-menu-rotated');
                    ccMenuLink.attr('aria-expanded', 'false');
                    ccRightCol.hide().css({
                        visibility: 'hidden',
                        'pointer-events': 'none'
                    });
                } else {
                    // Close siblings
                    ccLeftCol.find('.cc-nv-main-item').removeClass('cc-menu-active');
                    ccLeftCol.find('.cc-nav-arrow').removeClass('cc-menu-rotated');
                    ccLeftCol.find('.cc-nav-link').attr('aria-expanded', 'false');
                    ccLeftCol.find('.cc-nav-right').hide().css({
                        visibility: 'hidden',
                        'pointer-events': 'none'
                    });

                    // Open this one
                    ccMenuItem.addClass('cc-menu-active');
                    ccArrow.addClass('cc-menu-rotated');
                    ccMenuLink.attr('aria-expanded', 'true');

                    ccRightCol.show().css({
                        position: 'absolute',
                        top: 0,
                        left: '100%',
                        visibility: 'visible',
                        'pointer-events': 'auto'
                    });
                }
            });

            // 🔹 Hover behavior (desktop)
            ccMenuItem.on('mouseenter', () => {
                ccLeftCol.find('.cc-nv-main-item').removeClass('cc-menu-active');
                ccLeftCol.find('.cc-nav-arrow').removeClass('cc-menu-rotated');
                ccLeftCol.find('.cc-nav-link').attr('aria-expanded', 'false');
                ccLeftCol.find('.cc-nav-right').hide().css({
                    visibility: 'hidden',
                    'pointer-events': 'none'
                });

                ccMenuItem.addClass('cc-menu-active');
                ccArrow.addClass('cc-menu-rotated');
                ccMenuLink.attr('aria-expanded', 'true');

                ccRightCol.show().css({
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    visibility: 'visible',
                    'pointer-events': 'auto',
                });
            });

            ccMenuItem.on('mouseleave', () => {
                if (!ccRightCol.is(':hover')) {
                    ccMenuItem.removeClass('cc-menu-active');
                    ccArrow.removeClass('cc-menu-rotated');
                    ccMenuLink.attr('aria-expanded', 'false');
                    ccRightCol.hide().css({
                        visibility: 'hidden',
                        'pointer-events': 'none'
                    });
                }
            });

            ccRightCol.on('mouseleave', () => {
                ccMenuItem.removeClass('cc-menu-active');
                ccArrow.removeClass('cc-menu-rotated');
                ccMenuLink.attr('aria-expanded', 'false');
                ccRightCol.hide().css({
                    visibility: 'hidden',
                    'pointer-events': 'none'
                });
            });
        }

        ccLeftCol.append(ccMenuItem);
    });
}


function ccInitVerticalNav() {
    $('div[class~="#main-navigation-dropdown"]').each(function() {
        const ccDropdown = $(this);
        const ccGrid = ccDropdown.find('div[class~="#main-navigation-mega-grid"]').first();
        if (ccGrid.length) {
            const menuItems = [];
            ccgetMenuItems(ccGrid, menuItems, 1);
            ccGrid.hide();
            let ccNewNav = ccDropdown.find('.cc-new-vertical-nav');
            if (!ccNewNav.length) {
                ccNewNav = $('<div class="cc-new-vertical-nav"></div>');
                ccDropdown.find('div[class~="#container"]').prepend(ccNewNav);
            }
            ccNewNav.empty();
            renderTwoColumnMenu(menuItems, ccNewNav);
        }
    });
}
ccInitVerticalNav();


/* ===================== STICKY ADD TO CART ===================== */

const stickyAddtocart = `<div class="cc-atc-hardcode-sticky-85265929">
    <div class="cc-atc-wrap">
      <div class="cc-atc-top">
        <div class="cc-prod-prop">
          <div class="cc-atc-pro-img"><img src=""></div>
          <div class="cc-atc-pro-name"></div>
        </div>
        <div class="cc-atc-pro-price">
        </div>
      </div>
      <div class="cc-atc-bottom">
        <div class="cc-quantity-wrap">
          <button class="cc-q-minus">−</button>
          <span class="cc-q-input"> 
            <input id="cc-input-quantity" value="1" type="number"> 
          </span>
          <button class="cc-q-plus">+</button>
        </div>
        <div class="cc-btn-atc">
          <button class="cc-action-atc">
            Add to cart
          </button>
        </div>
      </div>
    </div>
  </div>`;
var qty;
var ccProSel = $(document).find('#MainContent');
$('body').prepend($(stickyAddtocart));
const ccObj = $(document).find('.cc-atc-hardcode-sticky-85265929');

function ccGetProImg() {
    const ccSelImg = ccProSel.find('.swiper-wrapper img').attr('src');
    ccObj.find('.cc-atc-pro-img img').attr('src', ccSelImg);
}
setTimeout(ccGetProImg, 500);

function ccGetProName() {
    const ccName = ccProSel.find('h1.heading-font').text();
    ccObj.find('.cc-atc-pro-name').text(ccName);
}
ccGetProName();

function ccGetPrice() {
    const ccPrice = ccProSel.find('#b-price').html();
    ccObj.find('.cc-atc-pro-price').html(ccPrice);
}
setInterval(ccGetPrice, 1000);

function ccCommonQty() {
    var ccQuaSOld = ccProSel.find('.\\#product-qty-selector-input').val();
    var ccQuaSOldTrim = ccQuaSOld.replace(/[^0-9]/g, '');
    ccObj.find('#cc-input-quantity').val(ccQuaSOldTrim);
}

ccObj.find('.cc-q-minus').on('click', () => {
    qty = $('#cc-input-quantity').val();
    if (qty != 1 && qty != '') {
        qty--;
        ccObj.find('#cc-input-quantity').val(qty);
        ccProSel.find('.\\#product-qty-selector-input').val(qty);
    }
});

ccObj.find('.cc-q-plus').on('click', () => {
    qty = ccObj.find('#cc-input-quantity').val();
    if (qty == '') {
        qty = 0;
    }
    qty++;
    ccObj.find('#cc-input-quantity').val(qty);
    ccProSel.find('.\\#product-qty-selector-input').val(qty);
});

ccObj.find('#cc-input-quantity').on('change keyup', () => {
    setTimeout(() => {
        const cqy = $('#cc-input-quantity').val();
        ccProSel.find('.\\#product-qty-selector-input').val(cqy);
    }, 500);
});

$(document).on('change keyup', '.\\#product-qty-selector-input', function() {
    setTimeout(ccCommonQty, 500);
});

ccObj.find('.cc-action-atc').on('click', () => {
    ccProSel.find('.shopify-product-form .\\#products-counter-wrapper .\\#button').trigger('click');
});

function ccAtcActive() {
    let hHeight = 0;
    if ($('#mainHeadersections--17882039484633__g_header').length) {
        hHeight += $('#mainHeadersections--17882039484633__g_header').height();
    }
    let ccPos;
    if (ccProSel.find('.shopify-product-form .\\#products-counter-wrapper .\\#button').length) {
        ccPos = ccProSel.find('.shopify-product-form .\\#products-counter-wrapper .\\#button').offset().top +
            ccProSel.find('.shopify-product-form .\\#products-counter-wrapper .\\#button').height();
    }
    if ($(window).scrollTop() + hHeight > ccPos) {
        $('body').addClass('cc-atc-scroll-active');
    } else {
        $('body').removeClass('cc-atc-scroll-active');
    }
}
ccAtcActive();

window.addEventListener('scroll', () => {
    ccAtcActive();
}, true);

/* ========== SHIFTING PRODUCT DETAILS TO ACCORDION ========== */

function setDetails() {
    const detailsHtml = `<div class="cc-details-92812191">
      <div class="cc-details-warp">
        <div class="cc-details-list">
          <button class="cc-detail-button" type="button" aria-label="Product Details"
            title="Product Details" aria-controls="detail__drop">
            <span class="cc-button-text">
              Product Details
            </span>
            <span class="cc-button-image">
              <img class="cc-btn-plus"
                src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-plus.png?v=1775764809" aria-hidden="true" alt="Open Icon" />
              <img class="cc-btn-minus"
                src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-minus.png?v=1775764808" aria-hidden="true" alt="Close Icon" />
            </span>
          </button>
          <div class="cc-content-details" id="detail__drop">
            <div class="cc-content-inner">
              <div class="cc-content-description">
              </div>
              <div class="cc-content-faq">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;

    $('main#MainContent section.shopify-section:has(.\\#product) .\\#container')
        .append(detailsHtml);
    const detSel = $('.cc-details-92812191');

    const detail = $('.\\#product-meta .\\#product-meta-block:has(.\\#product-description)').wrapAll();
    const faq = $('.\\#product-meta .\\#product-meta-block:has(.faq)').wrapAll();
    detSel.find('.cc-content-description').append(detail);
    detSel.find('.cc-content-faq').append(faq);

    detSel.find('.cc-detail-button').on('click', function() {
        $(this).parent().toggleClass('cc-details-active');
    });
}
setDetails();

/* ========== VALUE PROPOSITION IN PRODUCT PAGE ========== */

const ccValuePropCamp = `<div class="cc-vp-section--10892566 cc-desktop" style="display: none;">
    <div class="cc-vp-wrap">
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-fast-shipping.svg?v=1775764808" alt="Fast Shipping Icon">
        <div class="cc-vp-text">Fast Shipping</div>
        <div class="cc-vp-popup">
          Get your order quickly, straight to your door.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-easy-returns.svg?v=1775764808" alt="Easy Returns Icon">
        <div class="cc-vp-text">Easy Returns</div>
        <div class="cc-vp-popup">
          Hassle-free returns for peace of mind.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-expert-support.svg?v=1775764808" alt="Expert Support Icon">
        <div class="cc-vp-text">Expert Support (9–5)</div>
        <div class="cc-vp-popup">
          Our team is here to help, Monday to Friday.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-installation-guide.svg?v=1775764808" alt="Installation Guide Icon">
        <div class="cc-vp-text">Installation Guides</div>
        <div class="cc-vp-popup">
          Step-by-step resources for every product.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-free-shipping.svg?v=1775764808" alt="Free Shipping Icon">
        <div class="cc-vp-text">Free Shipping Over $599</div>
        <div class="cc-vp-popup">
          Save on large orders automatically at checkout.
        </div>
      </div>
    </div>
  </div>
  <div class="cc-vp-section--10892566 cc-mobile" style="display: none;">
    <div class="cc-vp-wrap">
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-fast-shipping.svg?v=1775764808" alt="Fast Shipping Icon">
        <div class="cc-vp-text">Fast <br> Shipping</div>
        <div class="cc-vp-popup cc-first">
          Get your order quickly, straight to your door.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-easy-returns.svg?v=1775764808" alt="Easy Returns Icon">
        <div class="cc-vp-text">Easy <br> Returns</div>
        <div class="cc-vp-popup">
          Hassle-free returns for peace of mind.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-expert-support.svg?v=1775764808" alt="Expert Support Icon">
        <div class="cc-vp-text">Expert Support <br> (9–5)</div>
        <div class="cc-vp-popup cc-last">
          Our team is here to help, Monday to Friday.
        </div>
      </div>
    </div>
    <div class="cc-vp-wrap">
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-installation-guide.svg?v=1775764808" alt="Installation Guide Icon">
        <div class="cc-vp-text">Installation <br> Guides</div>
        <div class="cc-vp-popup">
          Step-by-step resources for every product.
        </div>
      </div>
      <div class="cc-vp-list">
        <img src="https://cdn.shopify.com/s/files/1/2953/4644/files/icon-free-shipping.svg?v=1775764808" alt="Free Shipping Icon">
        <div class="cc-vp-text">Free Shipping <br> Over $599</div>
        <div class="cc-vp-popup">
          Save on large orders automatically at checkout.
        </div>
      </div>
    </div>
  </div>`;
$('main#MainContent section.shopify-section:has(.\\#product) .\\#product-grid').after($(ccValuePropCamp));
const ccvalueProp = $('.cc-vp-section--10892566.cc-mobile');
ccvalueProp.on('click', '.cc-vp-list', function() {
    if ($(this).attr('class').indexOf('isActive') >= 0) {
        ccvalueProp.find('.cc-vp-list').removeClass('isActive');
    } else {
        ccvalueProp.find('.cc-vp-list').removeClass('isActive');
        $(this).addClass('isActive');
    }
});
$(document).on('click', (e) => {
    if (!$(e.target).closest('.cc-vp-section--10892566.cc-mobile .cc-vp-list').length) {
        $('.cc-vp-list.isActive').removeClass('isActive');
    }
});